import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";
import APIS from "../../constant/Endpoint";
import usePostHook from "../../customHooks/usePostHook";

const AddProductComponent = loadable(
  () => import("../../components/InventoryInfo/AddProduct")
);
const AddProduct = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["inventory-info"],
    navigateURL: "/accounting/inventory",
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = APIS.PRODUCT;
    const formData = {
      ...values,
      is_group: false,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      <div className={tw`grid grid-cols-2 `}>
        <h1 className={tw`font-semibold text-xl leading-10`}>Add Product</h1>
      </div>
      <AddProductComponent
        handleCreate={handleCreate}
        isLoading={isPostLoading}
      />
    </div>
  );
};

export default AddProduct;
